import CustomList from "components/list/custom";
import { AmountCell2, DateCell } from "@/modules/work/billables/cells";
import { Link } from "react-router-dom";
import { createFilteredUrl } from "@/lib/urlHelpers";

export function Highvalue() {
  const columns = [
    {
      accessorKey: "company",
      header: "Company",
      
    },
    {
      accessorKey: "name",
      header: "Billable",
      cell: ({ row }) => {
        const name = row.getValue("name");
        const companyId = row.original.company_id;

        const baseFilters = {
          contacts: {
            projects: {
              jobs: {
                billables: {
                  status: { _eq: "billed" },
                },
              },
            },
          },
          id: { _eq: companyId },
          deep: {
            contacts: {
              _filter: {
                projects: {
                  jobs: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                },
              },
              projects: {
                _filter: {
                  jobs: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                },
                jobs: {
                  _filter: {
                    billables: {
                      status: { _eq: "billed" },
                    },
                  },
                  billables: {
                    _filter: {
                      status: { _eq: "billed" },
                    },
                  },
                },
              },
            },
          },
        };

        return (
          <Link
            to={createFilteredUrl("../status/billed", baseFilters)}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:underline cursor-pointer"
          >
            {name}
          </Link>
        );
      },
    },
    {
      accessorKey: "amount",
      header: "Amount",
      cell: AmountCell2,
    },
    {
      accessorKey: "due_date",
      header: "Due Date",
      cell: DateCell,
    },
  ];

  return (
    <CustomList
      title="High-value billables"
      info="Top 5 companies with the highest single billable amount."
      endPoint="custom-ui/get-high-value-billables"
      columns={columns}
      hidePagination={true}
    />
  );
}
